export const PLACEHOLDER_REGO = "DEFAULTREGO";
export const PLACEHOLDER_MAKE = "DEFAULTMAKE";
export const PLACEHOLDER_MODEL = "DEFAULTMODEL";
export const PLACEHOLDER_VIN = "DEFAULTVINNUMBERS";

export function normalizeRego(rego) {
  return typeof rego === "string" ? rego.trim().toUpperCase() : "";
}

export function normalizeMake(make) {
  return typeof make === "string" ? make.trim().toUpperCase() : "";
}

export function normalizeModel(model) {
  if (model == null || model === "") return "";
  if (typeof model === "object") {
    const s = model.name ?? model.label ?? model.value ?? "";
    return String(s).trim().toUpperCase();
  }
  return String(model).trim().toUpperCase();
}

export function formatModelForDisplay(model) {
  if (model == null || model === "") return "";
  if (typeof model === "object") {
    return String(model.name ?? model.label ?? model.value ?? "");
  }
  return String(model);
}

export function normalizeVin(vin) {
  return typeof vin === "string" ? vin.trim() : "";
}

/** True when VIN looks like a temporary / generated value, not a real VIN. */
export function isGeneratedPlaceholderVin(vin) {
  return /^GEN-/i.test(normalizeVin(vin));
}

export function isPlaceholderRegoValue(rego) {
  const r = normalizeRego(rego);
  if (!r) return true;
  if (r === PLACEHOLDER_REGO || r === "PENDING") return true;
  return /^PENDING-LINK-/.test(r);
}

/**
 * Contract "confirm vehicle" gate. Make, model, and VIN are optional on that
 * form — only a missing/placeholder registration should block signing.
 */
export function vehicleHasPlaceholderDetails(vehicle) {
  if (!vehicle) return true;
  return isPlaceholderRegoValue(vehicle.rego);
}

export function vinLooksPlaceholder(vehicle) {
  if (!vehicle?.vin) return false;
  const vin = normalizeVin(vehicle.vin);
  return vin === PLACEHOLDER_VIN || isGeneratedPlaceholderVin(vin);
}

export function makeLooksPlaceholder(make) {
  const m = normalizeMake(make);
  return !m || m === PLACEHOLDER_MAKE || m === "PENDING";
}

export function modelLooksPlaceholder(model) {
  const m = normalizeModel(model);
  return !m || m === PLACEHOLDER_MODEL || m === "PENDING";
}
